import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
	Col,
	Card,
	CardBody,
	CardHeader,
	Table,
	Label,
	Input,
	Media,
	Row,
} from "reactstrap";
import { Btn } from "AbstractElements";
import { fetchAdmins, handleSetPermission } from "../AdminUtils";

const AdminPermission = () => {
	const dispatch = useDispatch();
	const { id } = useParams();
	const [data, setData] = useState([]);
	const [detailData, setDetailData] = useState({
		id: 0,
		name: "",
		email: "",
		role: "",
	});
	const [isSaving, setIsSaving] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			const response = await fetchAdmins(dispatch, {
				"filter[id]": id,
				include: "permissions",
			});
			if (response.length) {
				setData(response[0].permissions);
				setDetailData(response[0]);
			}
		};
		fetchData();
	}, [id, dispatch]);

	const handleSave = async () => {
		if (isSaving) return;

		setIsSaving(true);

		try {
			/* payload is array of id permission that allow */
			const payload = [];

			data.forEach((item) => {
				item.features.forEach((child) => {
					child.permissions.forEach((permission) => {
						if (permission.access_allow) {
							payload.push(permission.id);
						}
					});
				});
			});

			await handleSetPermission(dispatch, detailData.id, payload);
		} finally {
			setIsSaving(false);
		}
	};

	const handleChangeParentCheckbox = (e) => {
		const { name, checked } = e.target;
		const [index] = name.split("-");
		const newData = [...data];
		newData[index].features.forEach((child) => {
			child.permissions.forEach((permission) => {
				permission.access_allow = checked;
			});
		});
		setData(newData);
	};

	const handleChangeChildCheckbox = (e) => {
		const { name, checked } = e.target;
		const [index, childIndex] = name.split("-");
		const newData = [...data];
		newData[index].features[childIndex].permissions.forEach((permission) => {
			permission.access_allow = checked;
		});
		setData(newData);
	};

	const handleChangeCheckbox = (e) => {
		const { name, checked } = e.target;
		const [index, childIndex, permissionIndex] = name.split("-");
		const newData = [...data];
		newData[index].features[childIndex].permissions[
			permissionIndex
		].access_allow = checked;
		setData(newData);
	};

	return (
		<>
			{data.length > 0 && (
				<Col sm="12" xl="12" lg="12" className="xl-100 box-col-12 order-1">
					<Card className="social-widget-card">
						<CardHeader>
							<Col>
								<Row>
									<Col>
										<h6>{detailData.name}</h6>
										<h6>{detailData.email}</h6>
										<h6>{detailData.role}</h6>
									</Col>
								</Row>
							</Col>
						</CardHeader>
					</Card>

					<Card className="social-widget-card">
						<CardHeader>
							<h5>{"List Permission"}</h5>
						</CardHeader>
						<CardBody>
							<Row>
								<Col>
									<Table size="sm">
										<thead className="table-light">
											<tr>
												<th scope="col">{"#"}</th>
												<th scope="col">{"Nama"}</th>
												<th scope="col" width="250px" className="text-center">
													Izinkan
												</th>
											</tr>
										</thead>
										<tbody>
											{data.map((item, index) => (
												<Fragment key={index}>
													<tr>
														<th scope="row"><h2>##{index + 1}</h2></th>
														<td><h2>{item.groupPermission_name}</h2></td>
														<td className="text-center">
															<Media
																body
																className="text-center icon-state switch-outline">
																<Label className="switch">
																	<Input
																		type="checkbox"
																		name={`${index}`}
																		checked={item.features.every((child) =>
																			child.permissions.every(
																				(permission) =>
																					permission.access_allow
																			)
																		)}
																		onChange={handleChangeParentCheckbox}
																		disabled={isSaving}
																	/>
																	<span className="switch-state bg-primary"></span>
																</Label>
															</Media>
														</td>
													</tr>
													{item.features.map((child, childIndex) => (
														<Fragment key={childIndex}>
															<tr
																key={childIndex}
																style={{ backgroundColor: "#999" }}>
																<th scope="row"><h4>#{childIndex + 1}</h4></th>
																<td><h4>{child.groupFeature_name}</h4></td>

																<td className="text-center">
																	<Media
																		body
																		className="text-center icon-state switch-sm">
																		<Label className="switch">
																			<Input
																				type="checkbox"
																				name={`${index}-${childIndex}`}
																				checked={child.permissions.every(
																					(permission) =>
																						permission.access_allow
																				)}
																				onChange={handleChangeChildCheckbox}
																				disabled={isSaving}
																			/>
																			<span className="switch-state"></span>
																		</Label>
																	</Media>
																</td>
															</tr>
															{child.permissions.map(
																(permission, permissionIndex) => (
																	<Fragment key={permissionIndex}>
																		<tr scope="row" key={permissionIndex}>
																			<th scope="row">{permissionIndex + 1}</th>
																			<td>{permission.name}</td>
																			<td className="text-center">
																				<Input
																					type="checkbox"
																					name={`${index}-${childIndex}-${permissionIndex}`}
																					className="form-check-input"
																					style={{ cursor: "pointer" }}
																					checked={permission.access_allow}
																					onChange={handleChangeCheckbox}
																					disabled={isSaving}
																				/>
																			</td>
																		</tr>
																	</Fragment>
																)
															)}
														</Fragment>
													))}
												</Fragment>
											))}

											<tr>
												<td colSpan="1" className="text-center">
													<Link
														to={`${process.env.PUBLIC_URL}/admin`}
														className="btn btn-warning m-r-10">
														<i className="fa fa-times-circle fa-lg me-2"></i>
														Kembali
													</Link>
												</td>
												<td colSpan="5" className="text-left">
													<Btn
														attrBtn={{
															color: "primary",
															className: "btn btn-primary m-r-10",
															disabled: isSaving,
															onClick: handleSave,
														}}>
														{isSaving ? (
															<>
																<i className="fa fa-spinner fa-spin fa-lg me-2"></i>
																Menyimpan...
															</>
														) : (
															<>
																<i className="fa fa-check-circle fa-lg me-2"></i>
																Simpan Perubahan
															</>
														)}
													</Btn>
												</td>
											</tr>
										</tbody>
									</Table>
								</Col>
							</Row>
						</CardBody>
					</Card>
				</Col>
			)}
		</>
	);
};

export default AdminPermission;